module.exports = __webpack_public_path__ + "img/news18_3.a3040b86.jpg";